/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowWaveRightDown = createReactComponent("outline", "arrow-wave-right-down", "IconArrowWaveRightDown", [["path", { "d": "M17 14h4v-4", "key": "svg-0" }], ["path", { "d": "M3 12c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2", "key": "svg-1" }]]);

export { IconArrowWaveRightDown as default };
//# sourceMappingURL=IconArrowWaveRightDown.mjs.map
